module.exports = __webpack_public_path__ + "img/logo.d9ed173.png";